import React from 'react';
import Header from './Header';
import Footer from './Footer';
import Gallery from './Gallery';

const GalleryPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header />
      <main className="flex-1">
        <div className="container mx-auto px-4 sm:px-6 pt-8 pb-2 text-center">
          <p className="text-xs font-semibold text-red-600 uppercase tracking-wider mb-1">Truckn Send It</p>
          <h1 className="text-3xl sm:text-4xl font-bold text-[#1e3a5f]">Gallery</h1>
          <p className="text-sm text-gray-500 mt-2 max-w-xl mx-auto">Photos from our community — loads, mates, machines and moments on the road.</p>
        </div>
        <Gallery />
      </main>
      <Footer />
    </div>
  );
};

export default GalleryPage;
